import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

var _excluded = ["alignSelf", "children", "className", "flex", "flexFill", "flexGrow", "flexShrink"];
var FlexboxChild = function FlexboxChild(_ref) {
  var alignSelf = _ref.alignSelf,
    children = _ref.children,
    className = _ref.className,
    flex = _ref.flex,
    flexFill = _ref.flexFill,
    flexGrow = _ref.flexGrow,
    flexShrink = _ref.flexShrink,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx(flexFill && 'flex-fill', flexGrow && "flex-grow-" + flexGrow, flexShrink && "flex-shrink-" + flexShrink, alignSelf && "align-self-" + alignSelf, className),
    style: {
      flex: flex
    }
  }, props), children);
};
FlexboxChild.propTypes = {
  alignSelf: PropTypes.oneOf(['start', 'end', 'center', 'between', 'around', 'initial']),
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * This is the shorthand for flex-grow, flex-shrink and flex-basis combined.
   */
  flex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Set this on a series of sibling elements to force them into widths equal
   * to their content (or equal widths if their content does not surpass their border-boxes)
   * while taking up all available horizontal space.
   * */
  flexFill: PropTypes.bool,
  /**
   * This defines the ability for a flex item to grow if necessary.
   * It accepts a unitless value that serves as a proportion.
   * It dictates what amount of the available space inside the flex container the item should take up.
   */
  flexGrow: PropTypes.number,
  /**
   * This defines the ability for a flex item to shrink if necessary.
   */
  flexShrink: PropTypes.number
};

export { FlexboxChild as default };
//# sourceMappingURL=FlexboxChild.js.map
